<template>
  <div>
    <v-dialog scrollable persistent v-model="model" max-width="1000">
      <material-card
        v-if="providerOffice !== null && providerOffice !== undefined"
        :title="title"
        icon="edit"
        :color="$vuetify.theme.themes.light.primary"
      >
        <v-card-text>
          <v-dialog v-model="cancelDialog" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{ $t("views.employers_view.cancel_wizard") }}
              </v-card-title>
              <v-card-text>
                {{
                  $t(
                    "components.inmemoryemployers.if_you_exit_the_wizard_any_changes_made_so_far"
                  )
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="cancelDialog = false">
                  {{ $t("views.employers_view.keep_working") }}
                </v-btn>
                <v-btn color="primary" text @click="cancelWizard()">
                  {{ $t("views.employers_view.cancel_anyway") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-container fluid grid-list-md>
            <v-form v-model="valid">
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="providerOffice.Office.OfficeNumber"
                    :label="$t('globals.number')"
                    :rules="[$rules.required, $rules.alphanumeric]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12">
                  <span class="text-h6 ml-1">
                    {{ $t("globals.address") }}
                  </span>
                  <canada-post-address
                    :address="providerOffice.Office.Address"
                    @update-address="
                      providerOffice.Office.Address = $event;
                      $forceUpdate();
                    "
                    @valid="validAddress = $event"
                    :isRequired="true"
                  />
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="providerOffice.WorkPhone"
                    :label="$t('headers.locals.phone_number')"
                    :rules="[rules.phone]"
                    v-mask="telephoneMask"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="providerOffice.Fax"
                    :label="$t('globals.fax_number')"
                    :rules="[rules.phone]"
                    v-mask="telephoneMask"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Email')"
                    v-model="providerOffice.Email"
                    :rules="[$rules.email]"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-xs-12">
                  <span>
                    {{
                      $t("components.claims.provider_dialog.primary_contact")
                    }}
                  </span>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="providerOffice.PrimaryContactFirstName"
                    :label="$t('headers.members_management.First Name')"
                    :rules="[$rules.validName]"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="providerOffice.PrimaryContactLastName"
                    :label="$t('headers.members_management.Last Name')"
                    :rules="[$rules.validLastName]"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
            </v-form>
            <v-form v-model="validBankAccountForm" ref="bankAccountForm">
              <v-row>
                <div class="col-12 col-xs-12">
                  <span>
                    {{
                      $t(
                        "components.claims.provider_dialog.direct_deposit_information"
                      )
                    }}
                  </span>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Institution Number')"
                    @input="
                      providerOffice.InstitutionNumber = $event;
                      tryValidateBankAccount();
                    "
                    :value="providerOffice.InstitutionNumber"
                    :rules="[$rules.canadianBankInstitutionNumber]"
                    :class="isBankAccountRequired() ? 'required' : ''"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Account Number')"
                    @input="providerOffice.AccountNumber = $event"
                    :value="providerOffice.AccountNumber"
                    :rules="[$rules.canadianBankAccountNumber]"
                    :class="isBankAccountRequired() ? 'required' : ''"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Transit Number')"
                    @input="
                      providerOffice.TransitNumber = $event;
                      tryValidateBankAccount();
                    "
                    :value="providerOffice.TransitNumber"
                    :rules="[$rules.canadianBankTransitNumber]"
                    :class="isBankAccountRequired() ? 'required' : ''"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6">
                  <v-checkbox
                    :label="
                      $t('headers.members_management.Verify Direct Deposit')
                    "
                    v-model="providerOffice.VerifyDirectDeposit"
                  ></v-checkbox>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!isProviderOfficeValid()"
            color="primary"
            @click="$emit('save')"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="confirmBankAccountDialog"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.addmemberwizard.confirm_bank_account_dialog_title')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="done"
      >
        <v-card-actions>
          <v-btn color text @click="confirmBankAccountDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="
              confirmBankAccountDialog = false;
              bankAccountValid = true;
            "
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "../CanadaPostAddress.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    CanadaPostAddress,
  },
  props: ["model", "providerOffice", "title"],
  directives: { mask },
  data() {
    return {
      error: null,
      saving: false,
      valid: false,
      selected: null,
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
      },
      telephoneMask: "(###) ### - ####",
      bankAccountValid: true,
      confirmBankAccountDialog: false,
      validBankAccountForm: false,
      cancelDialog: false,
      validAddress: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    ...mapActions("plansMembers", ["validateBankAccount"]),
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    isBankAccountRequired() {
      if (
        this.providerOffice.AccountNumber !== null &&
        this.providerOffice.AccountNumber !== undefined &&
        this.providerOffice.AccountNumber === ""
      ) {
        return true;
      }
      if (
        this.providerOffice.TransitNumber !== null &&
        this.providerOffice.TransitNumber !== undefined &&
        this.providerOffice.TransitNumber === ""
      ) {
        return true;
      }
      if (
        this.providerOffice.InstitutionNumber !== null &&
        this.providerOffice.InstitutionNumber !== undefined &&
        this.providerOffice.InstitutionNumber === ""
      ) {
        return true;
      }
      return false;
    },
    isBankAccountValid() {
      if (this.isBankAccountRequired()) {
        return this.validBankAccountForm;
      }
      if (this.$refs.bankAccountForm) {
        this.$refs.bankAccountForm.resetValidation();
      }
      return this.bankAccountValid;
    },
    async tryValidateBankAccount() {
      this.bankAccountValid = true;
      if (
        this.providerOffice &&
        this.providerOffice.InstitutionNumber &&
        this.providerOffice.TransitNumber &&
        this.$rules.canadianBankInstitutionNumber(
          this.providerOffice.InstitutionNumber
        ) === true &&
        this.$rules.canadianBankTransitNumber(
          this.providerOffice.TransitNumber
        ) === true
      ) {
        this.saving = true;
        try {
          const valid = (
            await this.validateBankAccount({
              payload: {
                InstitutionNumber: this.providerOffice.InstitutionNumber,
                TransitNumber: this.providerOffice.TransitNumber,
              },
            })
          ).data;

          if (!valid) {
            this.bankAccountValid = false;
            this.confirmBankAccountDialog = true;
          }
        } catch (error) {
          this.error = error;
        } finally {
          this.saving = false;
        }
      }
    },
    isProviderOfficeValid() {
      console.log("validation", this.providerOffice, this.validAddress);
      if (
        !this.providerOffice ||
        !this.providerOffice.Office ||
        !this.providerOffice.Office.Address
      ) {
        console.log("invalid");
        return false;
      }
      console.log(
        this.valid &&
          this.validAddress &&
          ((this.isBankAccountRequired() && this.isBankAccountValid()) ||
            !this.isBankAccountRequired())
      );
      return (
        this.valid &&
        this.validAddress &&
        ((this.isBankAccountRequired() && this.isBankAccountValid()) ||
          !this.isBankAccountRequired())
      );
    },
  },
};
</script>
